/* global module */
import Vue from "vue";
import Vuex from "vuex";
import * as getters from "./getters";
import * as actions from "./actions";

import wstudent from "wisaapp-webstudent/src/store/";

import { mutations } from "./mutations";

Vue.use(Vuex);
// const debug = process.env.NODE_ENV !== 'production'

const initialState = {
  debugging: false,
  isAnoniem: false,
  targetAudience: "",
  listOfConnections: localStorage.listOfConnections ? JSON.parse(localStorage.listOfConnections) : [],
  // redirectionUrlAfterLogin: '',
  userInfo: {
    loggedOutOnce: false,
    loggedInConnectionObject: {},
    loggedInUserInformation: {
      UserData: {}
    },
    leerlingID: "",
    isLeerkracht: false,
    isVwoLogin: false,
    isStudent: false,
    isRootLogin: false,
    isLeerling: false,
    isOuder: false,
    isHeverleeUser: false,
    screensRightsInformation: {
      personaliaBewerken: null,
      MijnGegevens: null,
      myprofile: null,
      Agenda: null,
      Aanwezigheden: null,
      Opleiding: null,
      Betalingen: null
    }
  },
  externalLinkForEvaluation: "",
  flags: {
    loggedIn: false,
    lockScreenForEachQueries: true,
    screenLocked: false,
    screenDisabled: false,
    showMenu: false,
    loginProcedureLocked: false,
    moduleChangingUsingMainMenu: false,
    isLoginRedirected: false
  },
  showedMessage: "",
  mainMenuItems: [],
  menubarItems: {
    left: [],
    title: "",
    right: [],
    rightAsTextButtons: [],
    isRightSideMenuOpen: false,
    rightSideMenuItems: []
  },
  oudersSpecific: {},
  versienummer: "1.3.5",
  projectNaam: "",
  currentDropdownMenu: "",
  activeModule: "",
  allConnectionTypes: [
    {
      _name: "Schoolware",
      _selected: true,
      type: "schoolware"
    },
    {
      _name: "Office 365",
      _selected: false,
      type: "office365"
    }
  ],
  allDropdownMenus: {}, // to be followed structure for its child element:
  /* {
    dropdownID: '', // required
    listOfItems: [], // required
    propertyToBeShown: '', // required
    keepDataAfterSelection:true, // optional
    title: 'Selecteer een vak', // optional
    isMultiSelect: false, // optional
    showFilterBar: false // optional
  } */
  closeDialog: false,
  lastActiveDialog: ""
};
export const state = JSON.parse(JSON.stringify(initialState));
state.initialValues = JSON.parse(JSON.stringify(initialState));

const store = new Vuex.Store({
  state: JSON.parse(JSON.stringify(state)),
  getters,
  actions,
  mutations,
  modules: {
    wstudent
  }
  /* ,strict: debug,
  plugins: debug ? [createLogger()] : [] */
});

if (module.hot) {
  module.hot.accept(
    [
      //  './state',
      "./getters",
      "./actions",
      "./mutations",
      "wisaapp-webstudent/src/store/"
    ],
    () => {
      store.hotUpdate({
        // state,
        getters,
        actions,
        mutations,
        modules: {
          wstudent
        }
      });
    }
  );
}

export default store;
